import {
  CONTENT_APPROVAL_FLEET_SUCCESS,
  CONTENT_APPROVAL_FLEET_ERROR,
  CONTENT_APPROVAL_FLEET_START,
  SAVE_CONTENT_APPROVAL_FLEET_START,
  SAVE_CONTENT_APPROVAL_FLEET_SUCCESS,
  SAVE_CONTENT_APPROVAL_FLEET_ERROR,
} from "../Constants/ContentApproveFleetConstatnt";
const initialState = {
  loading: false,
  data: [],
};

export default function ContenApproveFleetReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case CONTENT_APPROVAL_FLEET_START:
      return {
        ...state,
        loading: true,
      };
    case CONTENT_APPROVAL_FLEET_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case CONTENT_APPROVAL_FLEET_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case SAVE_CONTENT_APPROVAL_FLEET_START:
      return {
        ...state,
        loading: true,
      };
    case SAVE_CONTENT_APPROVAL_FLEET_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_CONTENT_APPROVAL_FLEET_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
